export default __webpack_public_path__ + "static/media/Ubuntu-Medium.5c7c9064.woff";